// extracted by mini-css-extract-plugin
export default {"form":"SimpleExpressionForm_form__Z81R6"};